import { render, staticRenderFns } from "./propertyAssetTenantForm.vue?vue&type=template&id=27192d63&%23default=true&"
import script from "./propertyAssetTenantForm.vue?vue&type=script&lang=js&"
export * from "./propertyAssetTenantForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports